// Copyright (c) 2026 aiApas LLC. All Rights Reserved.
// GuardRok — Proprietary and Confidential. Patent Pending.
// Unauthorized use or distribution is prohibited.

/// <reference types="vite/client" />
// Central config — all Supabase connection details live here.
// Values come from environment variables (VITE_ prefix = safe for browser).
// Set these in .env locally and in Cloudflare Pages → Settings → Environment Variables.

// Fallbacks prevent a blank screen if env vars are missing at build time.
// The app will load but auth will fail — which is recoverable.
export const SUPABASE_URL =
  (import.meta.env.VITE_SUPABASE_URL as string) || 'https://zrtnnrmmnlsxjubxdhgq.supabase.co'

export const SUPABASE_ANON_KEY =
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string) ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpydG5ucm1tbmxzeGp1YnhkaGdxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU4NzM1NDUsImV4cCI6MjA5MTQ0OTU0NX0.D3SZITzIskoOhk8h3A732Lg6tJgBfKbMXmFcbdZmVAE'

if (!import.meta.env.VITE_SUPABASE_URL) {
  console.warn(
    '[GuardRok] VITE_SUPABASE_URL not set — using hardcoded fallback. Set it in Cloudflare Pages env vars.'
  )
}
